import { GetRelationshipRequest } from './GetRelationshipRequest';

export class GetRelationshipsRequest {
    relationships: GetRelationshipRequest[] = [];
}